module.exports = __webpack_public_path__ + "img/northeast-fall-1920x550.2ae075f7.jpg";